import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c11fd5e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "radius card bottom10px",
  style: {borderRadius: '4px', padding:'1px'}
}
const _hoisted_2 = { class: "font-red" }
const _hoisted_3 = { class: "font-red" }
const _hoisted_4 = { type: "success" }


import { ref, defineComponent, defineProps } from 'vue'
import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
import { apiPostData, getI18n, convertUTC2LocalTime2, isChinese } from '../utils'
import store from '../store'

import PacakgeDataCard from './PacakgeDataCard.vue'
import PackageDataDetailCard from './PackageDataDetailCard.vue'
const __default__ = defineComponent({
  name: 'PackageCard'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  plan: {
    type: Object,
    require: true
  }
},
  setup(__props) {

// eslint-disable-next-line
const props = __props

function convertPackageStatus (plan: object) {
  const statusMap = {
    Inactive: '未激活',
    Activated: '已激活',
    Close: '关闭',
    Expired: '过期'
  }

  if (isChinese()) {
    return statusMap[plan.status]
  }

  return plan.status
}

const refIsExpand = ref(false)
const refUsage = ref({ code: '' })
function queryDataByPackage (orderId: string) {
  refIsExpand.value = !refIsExpand.value
  if (!refIsExpand.value) {
    return
  }
  const data = { simNo: store.state.simInfo.data.simNo, orderId: orderId }
  apiPostData('/h5/v1/sim/order/query-usage', data)
    .then(data => {
      if (data !== null && data !== undefined) {
        refUsage.value = data
      }
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_component_el_tag, {
      key: __props.plan.orderId,
      class: "auto-wrap",
      effect: "light"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_text, {
          class: "mx-1 value-font",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.plan.packageName), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })),
    (__props.plan.tradeId)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          class: "card-row",
          gutter: 20,
          align: "middle"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 9,
              class: "col-title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { class: "mx-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getI18n)('交易ID', 'tradeID')) + ":", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 15 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, {
                  class: "mx-1",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.plan.tradeId), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.plan.status!='Activated' && __props.plan.status!='Expired')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('订购时间', 'Subscribed Time')) + ":", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(convertUTC2LocalTime2)(__props.plan.createTime)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(getI18n)('最晚激活时间', 'Latest Activation Time')) + " ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(convertUTC2LocalTime2)(__props.plan.endTime)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('激活时间', 'Active Time')) + ":", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(convertUTC2LocalTime2)(__props.plan.activeTime)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('过期时间', 'Expire Time')) + ":", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(convertUTC2LocalTime2)(__props.plan.expireTime)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64)),
    _createVNode(_component_el_row, {
      class: "card-row",
      gutter: 20,
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 9,
          class: "col-title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, { class: "mx-1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('状态', 'Status')) + ":", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, {
              class: "mx-1 value-font",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(convertPackageStatus(__props.plan)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (__props.plan.status!='Inactive' && __props.plan.status!='Close')
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 9,
              class: "col-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  plain: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (queryDataByPackage(__props.plan.orderId)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getI18n)('查询流量', 'Query Data')), 1),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        (!refIsExpand.value)
                          ? (_openBlock(), _createBlock(_unref(ArrowDown), { key: 0 }))
                          : _createCommentVNode("", true),
                        (refIsExpand.value)
                          ? (_openBlock(), _createBlock(_unref(ArrowUp), { key: 1 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (refIsExpand.value && refUsage.value.code == 'ok')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createVNode(PacakgeDataCard, {
            summaryData: refUsage.value.data.summaryData
          }, null, 8, ["summaryData"]),
          _createVNode(PackageDataDetailCard, {
            historyQuota: refUsage.value.data.historyDailyData
          }, null, 8, ["historyQuota"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})